import { useMemo } from "react";
import ReactECharts from "echarts-for-react";

export const GIGA_PALETTE = ["#4285F4", "#DB4437", "#F4B400", "#0F9D58", "#AB47BC", "#00ACC1", "#FF7043", "#5C6BC0"];

const GigaVolumeChart = ({ labels = [], series = [], height = 320 }) => {
	const option = useMemo(
		() => ({
			color: GIGA_PALETTE,
			tooltip: { trigger: "axis" },
			legend: { type: "scroll", bottom: 0 },
			grid: { left: 48, right: 24, top: 24, bottom: 56 },
			xAxis: {
				type: "category",
				data: labels,
				axisLabel: { rotate: labels.length > 8 ? 30 : 0, fontSize: 11 },
			},
			yAxis: { type: "value", splitLine: { lineStyle: { color: "#eee" } } },
			series: (series || []).map((item) => ({
				name: item.name,
				type: "line",
				smooth: true,
				showSymbol: true,
				symbolSize: 6,
				data: item.data || [],
			})),
		}),
		[labels, series]
	);

	if (!labels.length || !series.length) return null;

	return <ReactECharts option={option} style={{ height, width: "100%" }} notMerge />;
};

export const GigaClusterBubbleChart = ({ clusters = [], growthField, onSelect, height = 380 }) => {
	const maxVol = Math.max(...clusters.map((cluster) => Number(cluster.searchVolume) || 0), 1);
	const option = useMemo(
		() => ({
			tooltip: {
				formatter: (params) => {
					const [volume, growth] = params.data?.value || [];
					const pct = `${growth >= 0 ? "+" : ""}${(Number(growth || 0) * 100).toFixed(0)}%`;
					return `${params.data?.name || ""}<br/>Volume ${Number(volume || 0).toLocaleString()}<br/>Growth ${pct}`;
				},
			},
			grid: { left: 64, right: 24, top: 24, bottom: 48 },
			xAxis: {
				type: "value",
				name: "Search volume",
				nameLocation: "middle",
				nameGap: 30,
				splitLine: { lineStyle: { color: "#eee" } },
			},
			yAxis: {
				type: "value",
				name: "Growth",
				splitLine: { lineStyle: { color: "#eee" } },
				axisLabel: { formatter: (value) => `${(Number(value) * 100).toFixed(0)}%` },
			},
			series: [
				{
					type: "scatter",
					data: clusters.map((cluster, index) => ({
						name: cluster.topic,
						value: [Number(cluster.searchVolume) || 0, Number(cluster[growthField]) || 0],
						itemStyle: { color: GIGA_PALETTE[index % GIGA_PALETTE.length] },
						cluster,
					})),
					symbolSize: (value) => 14 + ((Number(value?.[0]) || 0) / maxVol) * 46,
				},
			],
		}),
		[clusters, growthField, maxVol],
	);

	if (!clusters.length) return null;

	return (
		<ReactECharts
			option={option}
			style={{ height, width: "100%" }}
			notMerge
			onEvents={{
				click: (params) => {
					if (params?.data?.cluster) onSelect?.(params.data.cluster);
				},
			}}
		/>
	);
};

export default GigaVolumeChart;
